import React from "react";
import { STATUS_TONE, TONE_CLASSES } from "@/lib/constants";

export const StatusBadge = ({ status, testid }) => {
  const tone = STATUS_TONE[status] || "muted";
  return (
    <span
      data-testid={testid || `status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${TONE_CLASSES[tone]}`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
